import React, { useEffect } from 'react';
import { Grid, InputAdornment, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { cancelledHours, cancelledHoursFrequency } from 'app/models/Placement/PlacementMods';
import { payRateModStyles } from '../../PayRate/PayRateMod.styles';
import { FormInputDropdown } from '@AMIEWEB/Candidate/CandidateProfile/CandidateTabPanel/PersonalInfoTab/Form/Controls/FormInputDropdown';
import { selectCancelledHoursFrequency, selectIsUndoModal } from 'store/redux-store/placement-mods/selectors';
import { useDispatch, useSelector } from 'react-redux';
import { validDecimal } from 'app/helpers/numberHelper';
import { placementModsAction } from 'store/redux-store/placement-mods/slice';

export const CancelledSection = ({ isExpanded, isModEdit }: { isExpanded: boolean; isModEdit: boolean }) => {
  const { t } = useTranslation();
  const { control, setValue, clearErrors } = useFormContext();
  const { classes } = payRateModStyles({ isExpanded });
  const premiumPayValue = useWatch<any>({ name: 'cancellationHoursFrequencyId' });
  const premiumPayOptions = useSelector(selectCancelledHoursFrequency);
  const cancelledHoursValue = useWatch<any>({ name: cancelledHours });
  const cancelledDropDown = useWatch({ name: 'cancelledHoursFrequency' });
  const dispatch = useDispatch();
  const isUndoModal = useSelector(selectIsUndoModal);

  const handleStatusCodeChange = value => {
    setValue('cancelledHoursFrequency', value);
    const selectedValue = premiumPayOptions?.find(item => item.Description === value);
    setValue('cancellationHoursFrequencyId', selectedValue?.ID);
    if (value) {
      clearErrors('cancelledHoursFrequency');
    }
  };

  const getDefaultValue = () => {
    const value = premiumPayOptions?.find(item => parseFloat(item.ID) === premiumPayValue);
    setValue(cancelledHoursFrequency, value?.Description ?? null);
    setValue('cancellationHoursFrequencyId', value?.ID);
  };

  useEffect(() => {
    getDefaultValue();
  }, [premiumPayOptions]);

  useEffect(() => {
    if (isUndoModal) {
      getDefaultValue();
      dispatch(placementModsAction.setIsUndoModal(false));
    }
  }, [isUndoModal]);

  return (
    <>
    <Grid className={classes.factorMarginBillRate}>
      <Controller
        name={cancelledHours}
        control={control}
        render={({ field: { onChange, ...rest } }) => (
          <TextField
            value={cancelledHoursValue ?? null}
            variant="filled"
            className={classes.pricingTextfields}
            label={`${t(`placement.placementMods.${cancelledHours}`)}`}
            InputLabelProps={{
              shrink: cancelledHoursValue,
            }}
            onChange={e => {
              if (validDecimal(e.target.value, { numberLength: 3, decimalLength: 2 })) {
                setValue(cancelledHours, e.target.value);
                onChange(e.target.value);
              }
            }}
            InputProps={{
              readOnly: !isModEdit,
              style: {
                pointerEvents: isModEdit ? 'auto' : 'none',
              },
              startAdornment: (
                <>{cancelledHoursValue && <InputAdornment position="start">{t('currency.dollar')}</InputAdornment>}</>
              ),
              sx: { fontSize: '14px' },
            }}
            {...rest}
          />
        )}
      />
      </Grid>
      <Grid className={classes.factorMarginBillRate}>
        <Controller
          control={control}
          name={'cancellationHoursFrequencyId'}
          render={({ field: { onChange, ...rest } }) => {
            return (
              <FormInputDropdown
                labelClass={classes.cancelationFrequencyLabel}
                inputValue={cancelledDropDown}
                name={cancelledHoursFrequency}
                label={`${t(`placement.placementMods.${cancelledHoursFrequency}`)}`}
                customClass={classes.pricingTextfields}
                standard={true}
                options={premiumPayOptions?.length > 0 ? premiumPayOptions : []}
                handleChange={e => {
                  onChange(e);
                  handleStatusCodeChange(e.target.value);
                }}
                readOnly={!isModEdit}
              ></FormInputDropdown>
            );
          }}
        />
      </Grid>
    </>
  );
};
